import React, { createContext, useContext, useMemo, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useSettingsStore } from "../../hooks/useSettingsStore"; // ✅ ADD

export type Profile = {
  username: string;
  role?: string;
  displayName?: string;
  avatar_url?: string;
};

type ProfileContextValue = {
  profile: Profile | null;
  hasProfile: boolean;
  setProfile: (p: Profile | null) => void;
  logout: () => Promise<void>;
};

const ProfileContext = createContext<ProfileContextValue | undefined>(undefined);

export function ProfileProvider({ children }: { children: React.ReactNode }) {
  const { user, isAuthed, logout } = useAuth();
  const { state } = useSettingsStore(); // ✅ ADD

  const [override, setOverride] = useState<Partial<Profile> | null>(null);

  const profile: Profile | null = useMemo(() => {
    if (!isAuthed || !user) return null;

    // ✅ haal lokaal bewaarde settings
    const s = state?.profile;

    return {
      username: s?.username || user.username,
      role: user.role,
      avatar_url: s?.photoDataUrl || undefined,
      ...(override || {}),
    };
  }, [isAuthed, user, override, state]);

  const setProfile = (p: Profile | null) => {
    if (!p) setOverride(null);
    else setOverride({ ...p });
  };

  const value: ProfileContextValue = {
    profile,
    hasProfile: !!profile,
    setProfile,
    logout,
  };

  return <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>;
}

export function useProfile() {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error("useProfile moet binnen <ProfileProvider /> gebruikt worden");
  return ctx;
}
